import Lookup from 'src/componentes/select-async';
import ChecklistList from 'src/paginas/gestao-risco/auditoria/CheckList/ChecklistList';

const ModeloChecklistLookup = ({ params = {}, ...rest }) => {
  const defaultParams = {
    buscarChecklistRascunho: true, 
    buscarChecklistArquivado: true, 
    ...params,                     
  };

  return (
    <Lookup
      labelKey="nome"
      valueKey="id"
      showSearch={true}
      showNew={false}
      clearable={true}
      url="/ModeloChecklistLookup"
      searchComponent={ChecklistList}
      data={defaultParams}
      {...rest}
    />
  );
};

export default ModeloChecklistLookup;